import { DATA_SOURCE_TYPES, DATASOURCE_STATUS } from '../../../../constants'
import { ScanStatus } from '../../../../interfaces'
import { UnstructuredSummaryWidget } from '../../../dataSources/dataSourcesSlice'
import { DataSourceParentObjectTypes } from '../../../ObjectTypeAndPolicies/objectTypeAndPoliciesSlice'

export const mockDsRiksScoreWidgetData = {
  riskDensity: 50,
  riskScoreGraphData: [
    {
      name: '1-20',
      value: 80,
      totalObjects: 204
    },
    {
      name: '21-40',
      value: 5,
      totalObjects: 15
    },
    {
      name: '41-60',
      value: 3,
      totalObjects: 8
    },
    {
      name: '61-80',
      value: 1,
      totalObjects: 5
    },
    {
      name: '81-100',
      value: 8,
      totalObjects: 22
    }
  ]
}

export const mockAttributeDashboardWidgetV2Data = {
  topListByDs: [
    {
      list: [
        {
          id: '662a948c40b46d2236c6e5ed',
          name: 'Postal/Zip Code',
          internalName: 'POSTAL_CODE',
          columnCount: 0,
          attributesInstanceCount: 487
        },
        {
          id: '662a948c40b46d2236c6e5e8',
          name: 'USA Social Security Number (SSN)',
          internalName: 'US_SSN',
          columnCount: 0,
          attributesInstanceCount: 900
        },
        {
          id: '662a948c40b46d2236c6e5e7',
          name: 'Phone Number',
          internalName: 'PHONE_NUMBER',
          columnCount: 0,
          attributesInstanceCount: 574
        },
        {
          id: '662a948c40b46d2236c6e5e6',
          name: 'US Passport',
          internalName: 'US_PASSPORT',
          columnCount: 0,
          attributesInstanceCount: 1
        },
        {
          id: '662a948c40b46d2236c6e5e3',
          name: 'US Driver License',
          internalName: 'US_DRIVER_LICENSE',
          columnCount: 0,
          attributesInstanceCount: 461
        },
        {
          id: '662a948c40b46d2236c6e5e1',
          name: 'Us Bank Number',
          internalName: 'US_BANK_NUMBER',
          columnCount: 0,
          attributesInstanceCount: 28
        },
        {
          id: '662a948c40b46d2236c6e5d3',
          name: 'Org',
          internalName: 'ORG',
          columnCount: 0,
          attributesInstanceCount: 137
        },
        {
          id: '662a948c40b46d2236c6e5d2',
          name: 'Middle Name',
          internalName: 'MIDDLE_NAME',
          columnCount: 0,
          attributesInstanceCount: 189
        },
        {
          id: '662a948c40b46d2236c6e5d1',
          name: 'Last Name',
          internalName: 'LAST_NAME',
          columnCount: 0,
          attributesInstanceCount: 706
        },
        {
          id: '662a948c40b46d2236c6e5d0',
          name: 'First Name',
          internalName: 'FIRST_NAME',
          columnCount: 0,
          attributesInstanceCount: 875
        },
        {
          id: '662a948c40b46d2236c6e5cf',
          name: 'Name',
          internalName: 'name',
          columnCount: 0,
          attributesInstanceCount: 1365
        },
        {
          id: '662a948c40b46d2236c6e59e',
          name: 'IP Address',
          internalName: 'IP_ADDRESS',
          columnCount: 0,
          attributesInstanceCount: 29
        },
        {
          id: '662a948c40b46d2236c6e59c',
          name: 'ID Number',
          internalName: 'ID_NUMBER',
          columnCount: 0,
          attributesInstanceCount: 11
        },
        {
          id: '662a948c40b46d2236c6e59b',
          name: 'IBAN Code',
          internalName: 'IBAN_CODE',
          columnCount: 0,
          attributesInstanceCount: 2
        },
        {
          id: '662a948c40b46d2236c6e579',
          name: 'Gender',
          internalName: 'GENDER',
          columnCount: 0,
          attributesInstanceCount: 281
        },
        {
          id: '662a948c40b46d2236c6e561',
          name: 'Email Address',
          internalName: 'EMAIL_ADDRESS',
          columnCount: 0,
          attributesInstanceCount: 618
        },
        {
          id: '662a948c40b46d2236c6e548',
          name: 'Credit Card',
          internalName: 'CREDIT_CARD',
          columnCount: 0,
          attributesInstanceCount: 328
        },
        {
          id: '662a948c40b46d2236c6e534',
          name: 'Birth Date',
          internalName: 'BIRTH_DATE',
          columnCount: 0,
          attributesInstanceCount: 567
        },
        {
          id: '662a948b40b46d2236c6e516',
          name: 'Age',
          internalName: 'AGE',
          columnCount: 0,
          attributesInstanceCount: 9
        },
        {
          id: '662a948b40b46d2236c6e514',
          name: 'State',
          internalName: 'STATE',
          columnCount: 0,
          attributesInstanceCount: 60
        },
        {
          id: '662a948b40b46d2236c6e510',
          name: 'Street Name',
          internalName: 'STREET_NAME',
          columnCount: 0,
          attributesInstanceCount: 400
        },
        {
          id: '662a948b40b46d2236c6e50e',
          name: 'Address',
          internalName: 'address',
          columnCount: 0,
          attributesInstanceCount: 150
        }
      ],
      listWithColumnClassification: [],
      datasourceId: '66436e44dc403ae3567bafe9',
      isHighSensitive: false
    }
  ],
  topHighSensitiveList: [
    {
      list: [
        {
          id: '662a948c40b46d2236c6e5e8',
          name: 'USA Social Security Number (SSN)',
          internalName: 'US_SSN',
          columnCount: 0,
          attributesInstanceCount: 900
        },
        {
          id: '662a948c40b46d2236c6e5e6',
          name: 'US Passport',
          internalName: 'US_PASSPORT',
          columnCount: 0,
          attributesInstanceCount: 1
        },
        {
          id: '662a948c40b46d2236c6e5e3',
          name: 'US Driver License',
          internalName: 'US_DRIVER_LICENSE',
          columnCount: 0,
          attributesInstanceCount: 461
        },
        {
          id: '662a948c40b46d2236c6e59c',
          name: 'ID Number',
          internalName: 'ID_NUMBER',
          columnCount: 0,
          attributesInstanceCount: 11
        },
        {
          id: '662a948c40b46d2236c6e548',
          name: 'Credit Card',
          internalName: 'CREDIT_CARD',
          columnCount: 0,
          attributesInstanceCount: 328
        }
      ],
      datasourceId: '66436e44dc403ae3567bafe9',
      listWithColumnClassification: []
    }
  ]
}

export const mockClassificationAndLabelWidgetData = {
  totalObjectsCount: 10345,
  sensitiveObjectsCount: 8996,
  duplicateObjectsCount: 1460,
  duplicateBytesCount: 1024000,
  labellingWidgetData: [
    {
      id: '663b65aef2031c5ba8fe8c93',
      name: 'Restricted-R',
      type: 'LIGHTBEAM',
      objectCount: 200
    },
    {
      id: '66684c2a1a89fcc475c814c8',
      name: 'All Financials',
      type: 'LIGHTBEAM',
      objectCount: 112
    },
    {
      id: '66684c35f0af0e26c3f7b9a2',
      name: 'Tax forms',
      type: 'LIGHTBEAM',
      objectCount: 21
    }
  ],
  classificationWidgetData: {
    classificationsByDs: [
      {
        list: [
          {
            name: 'Unclassified',
            count: 1228352,
            subClass: ['Others'],
            riskyCount: 0
          },
          {
            name: 'Medical',
            count: 259,
            subClass: ['Health Insurance', 'Medical Others'],
            riskyCount: 0
          },
          {
            name: 'Identity',
            count: 2120,
            subClass: ['Govt ID', 'Driving License'],
            riskyCount: 0
          },
          {
            name: 'Legal',
            count: 729,
            subClass: [
              'Contracts',
              'Legal Others',
              'Copyrights / Patents',
              'NDA',
              'Lease Agreement'
            ],
            riskyCount: 0
          },
          {
            name: 'Financial',
            count: 5115,
            subClass: [
              'Invoices / Receipts',
              'Finance Others',
              'Earning Statement',
              'Tax Forms',
              'SEC',
              'Insurance',
              'Mortgage'
            ],
            riskyCount: 0
          },
          {
            name: 'Human Resource',
            count: 4587,
            subClass: ['Resume', 'HR Others'],
            riskyCount: 0
          }
        ],
        datasourceId: ''
      }
    ]
  }
}

export const mockDsScannedDataWidgetsData = {
  attributes: [
    {
      timestamp: '2025-04-03T00:00:00+00:00',
      value: 7832
    },
    {
      timestamp: '2025-04-02T00:00:00+00:00',
      value: 7832
    },
    {
      timestamp: '2025-04-01T00:00:00+00:00',
      value: 7832
    },
    {
      timestamp: '2025-03-31T00:00:00+00:00',
      value: 7832
    },
    {
      timestamp: '2025-03-30T00:00:00+00:00',
      value: 7832
    },
    {
      timestamp: '2025-03-29T00:00:00+00:00',
      value: 7832
    },
    {
      timestamp: '2025-03-28T00:00:00+00:00',
      value: 7832
    }
  ],
  documents: [
    {
      timestamp: '2025-04-03T00:00:00+00:00',
      value: 100
    },
    {
      timestamp: '2025-04-02T00:00:00+00:00',
      value: 300
    },
    {
      timestamp: '2025-04-01T00:00:00+00:00',
      value: 180
    },
    {
      timestamp: '2025-03-31T00:00:00+00:00',
      value: 150
    },
    {
      timestamp: '2025-03-30T00:00:00+00:00',
      value: 50
    },
    {
      timestamp: '2025-03-29T00:00:00+00:00',
      value: 280
    },
    {
      timestamp: '2025-03-28T00:00:00+00:00',
      value: 350
    }
  ],
  totalDataScanned: 1183020266,
  totalAttributeInstances: 7832
}

export const mockAlertSummaryWidgetData = {
  widget: [
    {
      name: 'TODAY',
      value: 8
    },
    {
      name: 'AGE_1_7',
      value: 10
    },
    {
      name: 'AGE_8_14',
      value: 21
    },
    {
      name: 'AGE_15_30',
      value: 0
    },
    {
      name: 'AGE_30_',
      value: 2
    }
  ],
  list: [
    {
      id: '670eb1b4cef0a1cc04836536',
      name: 'Test report-drive',
      status: 'ACTIVE_STATUS',
      severity: 'CRITICAL',
      assignees: ['admin@lightbeam.ai'],
      generatedAt: '2024-10-15T18:17:24.344000+00:00',
      dataSourceId: '66436e44dc403ae3567bafe9'
    },
    {
      id: '6718005f26a768cda6c38edd',
      name: 'Test report retention-drive',
      status: 'ACTIVE_STATUS',
      severity: 'CRITICAL',
      assignees: ['admin@lightbeam.ai'],
      generatedAt: '2024-10-22T19:43:27.260000+00:00',
      dataSourceId: '66436e44dc403ae3567bafe9'
    }
  ]
}

export const mockDsAccess360WidgetData = {
  widget: {
    usersCount: 4,
    openAccessObjects: 10,
    execessiveAccessObjects: 100,
    externalAccessObjects: 80,
    objectsCount: 250,
    crossDepartmentAccessObjects: 30,
    usersWithAccessToEntities: 2
  }
}

export const mockPolicyStatusWidgetData = {
  policies: [
    {
      id: '663b661cf2031c5ba8fe8c9a',
      name: 'Restricted Label',
      status: 'DELETING',
      type: 'DOCUMENT_LABELING_POLICY',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e627',
      createdAt: '2024-05-08T11:46:36.309000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '6663e618fd95a26e2211c568',
      name: 'abc',
      status: 'DELETING',
      type: 'RETENTION',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e625',
      createdAt: '2024-06-08T05:03:20.073000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '666853611a89fcc475c814f4',
      name: 'File Classification Labeling ',
      status: 'DELETING',
      type: 'DOCUMENT_LABELING_POLICY',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e627',
      createdAt: '2024-06-11T13:38:41.450000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '669a52fe85197f4fd13f8ae3',
      name: 'Demo2 Label Policy',
      status: 'DELETING',
      type: 'DOCUMENT_LABELING_POLICY',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e627',
      createdAt: '2024-07-19T11:50:22.175000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '66c7567cf487d2b3fe50ecd3',
      name: 'RahulRule',
      status: 'DELETING',
      type: 'INFORMATION_MANAGEMENT_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e623',
      createdAt: '2024-08-22T15:17:16.919000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '66d9a89967c39bc0a804fb65',
      name: 'Sample Rule',
      status: 'ACTIVE',
      type: 'RETENTION',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e625',
      createdAt: '2024-09-05T12:48:25.411000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '66f12a081ab088cb5cb9322e',
      name: 'lb-g-drive External Access',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2024-09-23T08:42:48.422000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '66f12a2afd3a5afc1dd8a146',
      name: 'lb-g-drive Internal Access',
      status: 'ACTIVE',
      type: 'INFORMATION_MANAGEMENT_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e623',
      createdAt: '2024-09-23T08:43:22.292000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '670eaf6e7b595dddf9991944',
      name: 'Test report',
      status: 'ACTIVE',
      type: 'ENTITY_LOCATION_POLICY',
      prefix: 'CLIENT_AI',
      policyTypeId: '662a948d40b46d2236c6e621',
      createdAt: '2024-10-15T18:07:41.962000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 21,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '670eb1047b595dddf9991af6',
      name: 'Test report retention',
      status: 'ACTIVE',
      type: 'RETENTION',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e625',
      createdAt: '2024-10-15T18:14:28.249000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 10,
      permittedAttributesCount: 0,
      permittedObjectsCount: 2
    },
    {
      id: '6710b21422aae2faea7d5241',
      name: 'outlook',
      status: 'ACTIVE',
      type: 'RETENTION',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e625',
      createdAt: '2024-10-17T06:43:31.779000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 26,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '6716358b2c96ac317ee98906',
      name: 'lb-onedrive External Access',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2024-10-21T11:05:47.272000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 12,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '671635a55138d7c50537608f',
      name: 'lb-onedrive Internal Access',
      status: 'ACTIVE',
      type: 'INFORMATION_MANAGEMENT_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e623',
      createdAt: '2024-10-21T11:06:13.736000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '671a6117be8f5352b7d6792c',
      name: 'test',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2024-10-24T15:00:39.137000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '675008b0a80a6eb78b94dbe9',
      name: 'm',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2024-12-04T07:45:52.503000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '6752f22ec4f2bedbfe4bb421',
      name: 'to check unclassfied',
      status: 'ACTIVE',
      type: 'ENTITY_LOCATION_POLICY',
      prefix: 'CLIENT_AI',
      policyTypeId: '662a948d40b46d2236c6e621',
      createdAt: '2024-12-06T12:46:38.550000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '675fd1eb26cdf51f33baa6cb',
      name: 'Test12',
      status: 'ACTIVE',
      type: 'DOCUMENT_LABELING_POLICY',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e627',
      createdAt: '2024-12-16T07:08:26.927000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '678741af5eb3cb4ca5cebbea',
      name: 'lb-s3 Detection',
      status: 'ACTIVE',
      type: 'ENTITY_LOCATION_POLICY',
      prefix: 'CLIENT_AI',
      policyTypeId: '662a948d40b46d2236c6e621',
      createdAt: '2025-01-15T05:03:43.157000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '678a2c471a78c52ad32f2012',
      name: 'asd',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2025-01-17T10:09:11.218000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '678a2cf7a22880c45fec8b7e',
      name: 'asdsd',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2025-01-17T10:12:06.917000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '67a0cefd3860e388b0439732',
      name: 'Revoke Test',
      status: 'ACTIVE',
      type: 'ACCESS_POLICY',
      prefix: 'ACCESS_CONTROL',
      policyTypeId: '66ac9a86e5bfc7af427c9e82',
      createdAt: '2025-02-03T14:13:16.499000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '67a4b7323860e388b0441f7b',
      name: 'PP Test',
      status: 'DELETING',
      type: 'RETENTION',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e625',
      createdAt: '2025-02-06T13:20:50.347000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '67a5b169d25051b3d80ac6b0',
      name: 'Alert Assignee Test',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2025-02-07T07:08:25.659000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '67baf9d20aa14a217f409cd9',
      name: 'Test sahil',
      status: 'ACTIVE',
      type: 'DATA_SHARING_POLICY',
      prefix: 'INFORMATION_EXPOSURE',
      policyTypeId: '662a948d40b46d2236c6e624',
      createdAt: '2025-02-23T10:34:58.636000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    },
    {
      id: '67ed7b76c66536080bb7725a',
      name: 'My Label Testing',
      status: 'DELETING',
      type: 'DOCUMENT_LABELING_POLICY',
      prefix: 'DATA_LIFECYCLE',
      policyTypeId: '662a948d40b46d2236c6e627',
      createdAt: '2025-04-02T18:01:26.853000+00:00',
      permittedEntitiesCount: 0,
      alertsCount: 0,
      permittedAttributesCount: 0,
      permittedObjectsCount: 0
    }
  ]
}

export const mockEntitiesRiskyWidgetData = {
  widgetData: {
    total: 136,
    totalRisky: 0,
    list: [
      {
        id: '66ac9a86e5bfc7af427c9e82',
        name: 'ACCESS_POLICY',
        description:
          'A policy to flag unauthorized access to sensitive information. E.g. Users from outside the organization have direct access to sensitive documents of the organization.',
        owner: 'LightBeam',
        systemDefined: true,
        entitiesInRiskCount: 0
      },
      {
        id: '662a948d40b46d2236c6e627',
        name: 'DOCUMENT_LABELING_POLICY',
        description: 'A policy to label documents based on user defined label definitions.',
        owner: 'LightBeam',
        systemDefined: true,
        entitiesInRiskCount: 0
      },
      {
        id: '662a948d40b46d2236c6e624',
        name: 'DATA_SHARING_POLICY',
        description:
          'A policy to flag sensitive information shared with unauthorized users. E.g. Users sharing files outside their organizations.',
        owner: 'LightBeam',
        systemDefined: true,
        entitiesInRiskCount: 0
      },
      {
        id: '662a948d40b46d2236c6e621',
        name: 'ENTITY_LOCATION_POLICY',
        description:
          "A policy to flag clients' data found in unintended data sources. E.g. Clients salary data found on Sharepoint.",
        owner: 'LightBeam',
        systemDefined: true,
        entitiesInRiskCount: 0
      },
      {
        id: '662a948d40b46d2236c6e623',
        name: 'INFORMATION_MANAGEMENT_POLICY',
        description:
          "A policy to flag sensitive information (customers/clients related or even generic) at unintended data sources (inside an org). E.g. Users sharing files containing a person's SSN on a slack channel containing members of their organizations.",
        owner: 'LightBeam',
        systemDefined: true,
        entitiesInRiskCount: 0
      },
      {
        id: '662a948d40b46d2236c6e625',
        name: 'RETENTION',
        description:
          "A policy to flag expired data. E.g. Former clients' data detected beyond mandated retention requirements.",
        owner: 'LightBeam',
        systemDefined: true,
        entitiesInRiskCount: 0
      }
    ]
  },
  usersCount: 10
}

export const mockDataSourcesRiskyWidget = {
  total: 60,
  risky: 14,
  datasources: [
    {
      id: '6639135dc9fa0d45757fa6fc',
      name: 'lb-g-drive1',
      type: 'GOOGLE_DRIVE'
    },
    {
      id: '663914b80fa450f1a9103806',
      name: 'kaif-one-drive .',
      type: 'ONE_DRIVE'
    },
    {
      id: '663915418cb06a763c52c46c',
      name: 'lb-outlook',
      type: 'OUTLOOK'
    },
    {
      id: '66436e44dc403ae3567bafe9',
      name: 'fastcomply-drive',
      type: 'GOOGLE_DRIVE'
    },
    {
      id: '66601e5692f0fb88c0b6e4ff',
      name: 'Jira-lb',
      type: 'JIRA'
    },
    {
      id: '66601ffea58f7370b71f6869',
      name: 'slack-lb',
      type: 'SLACK'
    },
    {
      id: '66829ab60dbbe9eaf741b940',
      name: "M's SP",
      type: 'SHAREPOINT'
    },
    {
      id: '66ba19bb0f71b64b39dd992b',
      name: 'cm_hubspot',
      type: 'HUBSPOT'
    },
    {
      id: '66c58b26e0aa5bc65e2c1363',
      name: 'S3',
      type: 'AWS_S3'
    },
    {
      id: '66c5eea7fd0b6f782fa9c396',
      name: 'kk-test',
      type: 'SMB'
    },
    {
      id: '66d862f6700de758210d1023',
      name: 'Rahul Azure Blob',
      type: 'AZURE_BLOB'
    },
    {
      id: '66ddb17e40fd0f32638c891c',
      name: 'Teams',
      type: 'MS_TEAMS'
    },
    {
      id: '6716354d5c5495f8d355bda1',
      name: 'lb-onedrive-test',
      type: 'ONE_DRIVE'
    },
    {
      id: '678741665eb3cb4ca5cebbe3',
      name: 'lb-s3',
      type: 'AWS_S3'
    }
  ]
}

export const mockLiveDataDiscoveryWidgetData = {
  attributes: [
    {
      timestamp: '2025-04-06T00:00:00+00:00',
      value: 12752359
    },
    {
      timestamp: '2025-04-05T00:00:00+00:00',
      value: 12752359
    },
    {
      timestamp: '2025-04-04T00:00:00+00:00',
      value: 12752359
    },
    {
      timestamp: '2025-04-03T00:00:00+00:00',
      value: 12752359
    },
    {
      timestamp: '2025-04-02T00:00:00+00:00',
      value: 12752359
    },
    {
      timestamp: '2025-04-01T00:00:00+00:00',
      value: 12752359
    },
    {
      timestamp: '2025-03-31T00:00:00+00:00',
      value: 12752359
    }
  ],
  documents: [
    {
      timestamp: '2025-04-06T00:00:00+00:00',
      value: 169411808401
    },
    {
      timestamp: '2025-04-05T00:00:00+00:00',
      value: 169411808401
    },
    {
      timestamp: '2025-04-04T00:00:00+00:00',
      value: 169411808401
    },
    {
      timestamp: '2025-04-03T00:00:00+00:00',
      value: 169411808401
    },
    {
      timestamp: '2025-04-02T00:00:00+00:00',
      value: 169411808401
    },
    {
      timestamp: '2025-04-01T00:00:00+00:00',
      value: 166765642484
    },
    {
      timestamp: '2025-03-31T00:00:00+00:00',
      value: 166764921588
    }
  ],
  totalDataScanned: 169411808401,
  totalAttributeInstances: 169411808401
}

export const mockPrivacyRightsWidgetData = {
  dsrTotal: 138,
  dsrOpen: 40,
  consentManagementOptIns: 421,
  consentManagementOptOuts: 299,
  cookieConsentNew: 3,
  cookieConsentTotal: 168,
  cookieConsentDomainsTotal: 17,
  consentManagementTotalConsents: 716
}

export const mockPrivacyAssessmentsWidgetData = {
  aiGovernanceAssessmentsNeedReview: 2,
  aiGovernanceAssessmentsTotal: 4,
  piaAssessmentsTotal: 66,
  piaAssessmentsNeedReview: 7,
  ropaProcessesTotal: 17,
  ropaProcessesNeedReview: 3
}

export const mockUnstructuredSummaryWidgetData: UnstructuredSummaryWidget = {
  objectsCount: 1615664,
  objectsAtRiskCount: 1200198,
  filesCount: 1244937,
  filesAtRiskCount: 1029902,
  messagesCount: 370461,
  messagesAtRiskCount: 370227,
  blobsCount: 155,
  rowsCount: 121,
  blobsAtRiskCount: 69
}

export const mockStructuredSummaryWidgetData = {
  ALL: {
    databasesCount: 99,
    tablesCount: 1827,
    totalClusterCount: 7
  }
}

export const mockMainDashboardRiskScoreWidgetData = [
  {
    id: '66c58b26e0aa5bc65e2c1363',
    name: 'S3',
    type: 'AWS_S3',
    totalRiskScore: 230,
    riskDensity: 100
  },
  {
    id: '678741665eb3cb4ca5cebbe3',
    name: 'lb-s3',
    type: 'AWS_S3',
    totalRiskScore: 15413727,
    riskDensity: 95
  },
  {
    id: '6798901d78906ea0d6f8d78f',
    name: 's3',
    type: 'AWS_S3',
    totalRiskScore: 38,
    riskDensity: 60
  },
  {
    id: '67efef32224f662f7797a2ca',
    name: 'Test confluence',
    type: 'CONFLUENCE',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '67481cf0840e6f31df72f94d',
    name: "K's GLue",
    type: 'GLUE',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '66436e44dc403ae3567bafe9',
    name: 'fastcomply-drive',
    type: 'GOOGLE_DRIVE',
    totalRiskScore: 5355,
    riskDensity: 29
  },
  {
    id: '66a3555c2b66f55b5cc9df84',
    name: 'Hubspot 212',
    type: 'HUBSPOT',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '66ba19bb0f71b64b39dd992b',
    name: 'CM_hubspot',
    type: 'HUBSPOT',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '66601e5692f0fb88c0b6e4ff',
    name: 'Jira-LB01',
    type: 'JIRA',
    totalRiskScore: 10905,
    riskDensity: 2
  },
  {
    id: '66ddb17e40fd0f32638c891c',
    name: 'Teams',
    type: 'MS_TEAMS',
    totalRiskScore: 4787488,
    riskDensity: 83
  },
  {
    id: '6718b6953651c9717fe9be28',
    name: 'SQL Review01',
    type: 'MSSQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '67af484f3ea9f9e00be3be81',
    name: 'lb-mssql',
    type: 'MSSQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '67d02f76a26402d7ec2a0e38',
    name: 'MsSql-ds',
    type: 'MSSQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '665f1c9d92f0fb88c0b6dd94',
    name: 'MySQL review',
    type: 'MySQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '6716354d5c5495f8d355bda1',
    name: 'lb-onedrive-test',
    type: 'ONE_DRIVE',
    totalRiskScore: 897,
    riskDensity: 50
  },
  {
    id: '663915418cb06a763c52c46c',
    name: 'lb-outlook',
    type: 'OUTLOOK',
    totalRiskScore: 1018,
    riskDensity: 18
  },
  {
    id: '663a21238cb06a763c52c531',
    name: 'Entity-RTBF',
    type: 'POSTGRESQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '67d44e37d4949c76c6573ca1',
    name: 'Pg-test',
    type: 'POSTGRESQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '67d44f8efe8437fd2c7141f0',
    name: 'postgres-1',
    type: 'POSTGRESQL',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '66c5eea7fd0b6f782fa9c396',
    name: 'KK-test',
    type: 'SMB',
    totalRiskScore: 3486239,
    riskDensity: 50
  },
  {
    id: '666023b5fd53546f94beb441',
    name: 'salesforce-lb',
    type: 'SALESFORCE',
    totalRiskScore: 0,
    riskDensity: 0
  },
  {
    id: '66829ab60dbbe9eaf741b940',
    name: "M's SP",
    type: 'SHAREPOINT',
    totalRiskScore: 5225567,
    riskDensity: 47
  },
  {
    id: '66e25d103233f57fc3d7f186',
    name: 'DLP-Data',
    type: 'SHAREPOINT',
    totalRiskScore: 35,
    riskDensity: 0
  },
  {
    id: '66601ffea58f7370b71f6869',
    name: 'slack-lb',
    type: 'SLACK',
    totalRiskScore: 709,
    riskDensity: 103
  }
]

export const mockSlackSummaryCountWidgetData = {
  summaryCount: { membersCount: 36, channelsCount: 6, scannedChannelsCount: 1 },
  policiesCount: 4
}

export const mockCopilotSummaryCountWidgetData = {
  summaryCount: { userCount: 20 },
  policiesCount: 4
}

export const mockTeamsSummaryCountWidgetData = {
  summaryCount: { membersCount: 36, channelsCount: 6, teamsCount: 2 },
  policiesCount: 4
}

export const mockMailsSummaryCountWidgetData = {
  gmailData: {
    usersCount: 10
  },
  outLookData: {
    usersCount: 10
  },
  policiesCount: 3,
  piiEmailsCount: 2,
  inboxEmailCount: 1,
  sentEmailsCount: 10
}

export const mockGenericSummaryCountWidgetData = {
  genericWidgetData: {
    projectsCount: 10,
    apiCount: 5
  },
  policiesCount: 3
}

export const mockJiraSummaryCountsWidgetData = {
  policiesCount: 4,
  projectsCount: 2,
  ticketsWithPIICount: 1
}

export const mockAWSS3SummaryCountWidgetData = {
  policiesCount: 4,
  objectsWithPIICount: 10,
  bucketsCount: 5
}

export const mockSmbSummaryCountsWidgetData = {
  fileSharesCount: 100,
  policiesCount: 5
}

export const Template1SummaryCountWidgetData = {
  gDriveWidgetData: {
    admin: 'admin@gdrvie.com',
    drivesCount: 10,
    usersCount: 3,
    groupsCount: 3,
    entitiesCount: 456,
    filesCount: 22511,
    location: 'USA',
    driveSize: 11291360081,
    driveName: ''
  },
  oneDriveWidgetData: {
    admin: 'testing@gmail.com',
    drivesCount: 1,
    usersCount: 1,
    groupsCount: 262,
    entitiesCount: 123,
    filesCount: 38,
    location: 'USA',
    driveSize: 76183047,
    driveName: ''
  },
  sharePointWidgetData: {
    admin: 'testing@gmail.com',
    drivesCount: 8624,
    usersCount: 0,
    groupsCount: 262,
    entitiesCount: 672,
    filesCount: 128566,
    location: 'USA',
    driveSize: 3031195754,
    driveName: ''
  },
  policiesCount: 10
}

export const mockDatasourceOverviewStatusWidgetData = {
  widgetData: {
    status: ScanStatus.scanning,
    objectsCount: {
      processedCount: 120,
      skippedCount: 10,
      pendingCount: 5,
      rescanPendingCount: 5
    }
  },
  syncInfo: {
    data: DATASOURCE_STATUS.scanning
  }
}

export const mockObjectTypeAndPoliciesWidgetData = {
  objectTypeCount: 5,
  policiesCount: 3,
  dataExtensionsCount: 1,
  businessUnitsCount: 1,
  parentObjectType: DataSourceParentObjectTypes.customer
}

export const mockDatabasesAndPoliciesWidgetData = {
  databasesCount: 5,
  policiesCount: 9
}

export const mockDuplicateDataWidgetData = {
  widget: {
    datasources: [
      {
        id: '#',
        name: 'Google Drive',
        type: DATA_SOURCE_TYPES.gdrive,
        totalDuplicateBytes: 450000,
        numDuplicateObjects: 15
      }
    ]
  }
}

export const mockUserCountsWidgetData = {
  totalUsers: 100,
  activeUsers: 70,
  deletedUsers: 3,
  disabledUsers: 7,
  externalUsers: 15,
  guestUsers: 5
}
